import { createContext, useContext } from "react";
import type { HttpAgent } from "@ag-ui/client";
import type { SubagentEvent } from "~/components/assistant-v2/SubagentActivity";

const AgentContext = createContext<HttpAgent | null>(null);

export const AgentProvider = AgentContext.Provider;

export function useAgent(): HttpAgent {
  const agent = useContext(AgentContext);
  if (!agent) {
    throw new Error("useAgent must be used within AgentProvider");
  }
  return agent;
}

// Subagent events context — provided by ConversationRuntime, consumed by DefaultToolMessage
const EMPTY_MAP = new Map<string, SubagentEvent[]>();
const SubagentEventsContext = createContext<Map<string, SubagentEvent[]>>(EMPTY_MAP);

export const SubagentEventsProvider = SubagentEventsContext.Provider;

export function useSubagentEventsForTool(toolCallId: string): SubagentEvent[] {
  const map = useContext(SubagentEventsContext);
  return map.get(toolCallId) ?? [];
}
